import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../services/api';
import Page from '../components/Layout/Page';
import './AuthPages.css';

const PWD_RE = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{8,}$/;

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (password !== confirm) { setError('Les mots de passe ne correspondent pas.'); return; }
    if (!PWD_RE.test(password)) {
      setError('Le mot de passe doit contenir au moins 8 caractères, une majuscule, une minuscule, un chiffre et un caractère spécial (!@#$%...).');
      return;
    }
    setLoading(true);
    try {
      await api.post('/api/auth/reset-password', { token, new_password: password });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'Lien invalide ou expiré.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <Page largeur="etroite" titre="Nouveau mot de passe">
      <div className="zk-carte zk-auth-carte">
        {!token ? (
          <div className="zk-auth-etat">
            <h2>Lien invalide</h2>
            <p>Ce lien de réinitialisation est invalide ou expiré.</p>
            <Link to="/forgot-password" className="zk-bouton plein">Demander un nouveau lien</Link>
          </div>
        ) : done ? (
          <div className="zk-auth-etat" role="status">
            <h2>Mot de passe mis à jour</h2>
            <p>Votre mot de passe a été réinitialisé.</p>
            <Link to="/login" className="zk-bouton plein">Se connecter</Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <p className="zk-auth-aide" style={{ margin: '0 0 14px' }}>
              8 caractères minimum, avec une majuscule, une minuscule, un chiffre et un caractère spécial.
            </p>
            <div className="zk-champ">
              <label htmlFor="reset-mdp">Nouveau mot de passe</label>
              <input id="reset-mdp" type="password" autoComplete="new-password" required placeholder="8 caractères minimum"
                value={password} onChange={(e) => setPassword(e.target.value)} />
            </div>
            <div className="zk-champ">
              <label htmlFor="reset-confirmation">Confirmer le mot de passe</label>
              <input id="reset-confirmation" type="password" autoComplete="new-password" required placeholder="Répétez le mot de passe"
                value={confirm} onChange={(e) => setConfirm(e.target.value)} />
            </div>
            {error && <div role="alert" className="zk-alerte erreur" style={{ marginBottom: 14 }}>{error}</div>}
            <button type="submit" className="zk-bouton plein" disabled={loading}>
              {loading ? 'Mise à jour…' : 'Réinitialiser le mot de passe'}
            </button>
          </form>
        )}
      </div>
    </Page>
  );
}
